<template>
  <modal
    :show.sync="showModal"
    header-classes="justify-content-center"
    :disable-background-close="true"
    @close="handleClose"
  >
    <h4 slot="header" class="title title-up">
      Add to Recruitment Depth Chart
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <el-row>
      <label class="col-md-4 col-form-label" />
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="newRecruitmentDepthChartPerson"
        placeholder="Select person..."
      >
        <el-option
          v-for="item in addablePeople"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>
    <el-row>
      <collapse
        ref="childCollapseComponent"
        v-show="!newRecruitmentDepthChartPerson"
      >
        <collapseItem
          title="Don't see who you're looking for?"
          class="bold-collapse-title"
          :show-caret="false"
        >
          <newPersonForm
            ref="childFormComponent"
            :is-embedded-in-modal="true"
            @savedPerson="captureSavedPerson($event)"
          />
        </collapseItem>
      </collapse>
    </el-row>
    <br>
    <el-row v-show="newRecruitmentDepthChartPerson">
      <label class="col-md-4 col-form-label">Which Column?</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="recruitmentDepthChartColumnId"
        placeholder="Select Column..."
      >
        <el-option
          v-for="item in recruitmentDepthChartColumns"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>

    <p v-if="validationError === true" style="color: red;">
      A person is required.
    </p>
    <br><br>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Add
      </p-button>
      <p-button type="danger" v-if="saving">
        Adding...
      </p-button>
            &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';
import newPersonForm from '../People/NewUserForm';
import collapse from '../UIComponents/Collapse/Collapse';
import collapseItem from '../UIComponents/Collapse/CollapseItem';

const RecruitmentDepthChartsRepository = RepositoryFactory.get('recruitmentDepthCharts');

function validateForm(newRecruitmentDepthChartPerson) {
    return !!newRecruitmentDepthChartPerson;
}

export default {
    name: 'AddRecruitmentDepthChartModal',
    components: {
        Modal,
        collapse,
        collapseItem,
        newPersonForm
    },
    data() {
        return {
            showModal: false,
            material: '',
            validationError: false,
            addablePeople: [],
            newRecruitmentDepthChartPerson: '',
            error: '',
            saving: false,
            recruitmentDepthChartColumns: [
                { id: 1, name: 'Potential Candidates' },
                { id: 2, name: 'Top Candidates' },
                { id: 3, name: 'Invited to Apply' },
                { id: 4, name: 'Applied' },
                { id: 5, name: 'Declined Invitation' },
                { id: 6, name: 'Not Invited to Apply' }
            ],
            recruitmentDepthChartColumnId: 1
        };
    },
    computed: {
        ...mapState({
            lastLocation: (state) => state.lastLocation
        })
    },
    methods: {
        captureSavedPerson(event) {
            this.$message(`Successfully saved ${event.name} as a contact.`);
            this.getAddableRecruitmentDepthChartList(this.lastLocation);
            this.newRecruitmentDepthChartPerson = event;
            this.$refs.childFormComponent.clearInputs();
            this.$refs.childCollapseComponent.deactivateAll();
        },
        handleSave() {
            this.saving = true;
            if (!validateForm(this.newRecruitmentDepthChartPerson)) {
                this.validationError = true;
                this.saving = false;
                return;
            }

            const newRecruitmentDepthChartPersonId = Number.isInteger(this.newRecruitmentDepthChartPerson)
            // case when person is newly created, in which case an object of
            // { id, name } must be passed to display their name as the option label
                ? this.newRecruitmentDepthChartPerson
            // case when person is selected from addablePeople
                : this.newRecruitmentDepthChartPerson.id;

            RecruitmentDepthChartsRepository.addRecruitmentDepthChart(
                newRecruitmentDepthChartPersonId, this.recruitmentDepthChartColumnId, this.lastLocation
            )
                .then((response) => {
                    this.saving = false;
                    this.$emit('recruitmentDepthChartChange');
                    this.$emit('save');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.$message.error(error.response.data.message);
                });

            this.$emit('close');

            this.newRecruitmentDepthChartPerson = '';
            this.recruitmentDepthChartColumnId = 1;
            this.validationError = false;
        },
        handleClose() {
            this.newRecruitmentDepthChartPerson = '';
            this.recruitmentDepthChartColumnId = 1;
            this.validationError = false;
            this.$refs.childFormComponent.clearInputs();
            this.$refs.childCollapseComponent.deactivateAll();
            this.$emit('close');
        },
        getAddableRecruitmentDepthChartList() {
            RecruitmentDepthChartsRepository.getAddableRecruitmentDepthChartList(this.lastLocation)
                .then((response) => {
                    this.addablePeople = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getAddableRecruitmentDepthChartList();
            }
        }
    },
    created() {
        this.getAddableRecruitmentDepthChartList();
    },

};
</script>
